// extracted by mini-css-extract-plugin
export default {"hold-requests":"HoldRequests_hold-requests__dZ8xi"};